import axios from "../../axios/index.js"


export default {
  AddNotification(notificationData) {
    return axios.post("notification", notificationData ,
      { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
  },
  // Envoi d'une notification pour un nouveau circulaire 
  sendNotification(id){
    return axios.get("sendnotification/" + id,
      { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
  },
  // Modifier l'état de la notification lors du consultation par le client (isSeen = 1)
  setNotificationSeen(id){
    return axios.get("updateSeen/" + id,
      { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
  },
  AddModele(modeleNotificationData) {
    return axios.post("notification/modele", modeleNotificationData ,
      { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
  },
  // Retourner la liste de toutes les notifications 
  getAllNotification() {
    return axios.get("/allnotification",
      { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
  },
  // Retourner les notifications non consultées pour le client connecté 
  findByCompte(code) {
    return axios.get("notificationClient/" + code,
      { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
  },
  // Retourner la liste des toutes notifications (consultées et non consultées) lors de l'appui sur le bouton vois toutes les notifications
  findAllByCompte(code) {
    return axios.get("/allnotificationClient/" + code,
      { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
  },
  getAllModele() {
    return axios.get("notification/modele",
      { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
  },
  getAllModeleAutomatic() {
    return axios.get("notification/modele/automatic",
      { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
  },
  deleteModele(id) {
    return axios.post("notification/modele/delete/" + id , null ,
      { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
  },
  getNews(username) {
    return axios.get("notification/" + username,
      { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
  },
  top10(username) {
    return axios.get("notification/top10/" + username,
      { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
  },
  historique(username) {
    return axios.get("notification/historique/" + username,
      { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
  },
  setView(username) {
    return axios.get("notification/view/" + username,
      { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
  },
}
